import React from "react";
import { motion } from "framer-motion";

const AboutSection = () => {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const slideLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1, type: "spring" } },
  };

  const slideRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1, type: "spring" } },
  };
  const data = [
    {
      title: "24/7 Support",
      text: "We as an academic service provider realize that scholars may need backing at any time. Our team is ready to support 24/7...",
      color: "bg-red-500",
      side: "left",
    },
    {
      title: "Client Satisfaction",
      text: "Client satisfaction is the key factor to us. We go above and beyond to ensure quality and outcomes...",
      color: "bg-teal-400",
      side: "right",
    },
    {
      title: "Quality Assistance",
      text: "The main factor that scholars should choose Zonduo is because of the quality support provided by our experts...",
      color: "bg-yellow-500",
      side: "left",
    },
    {
      title: "Thesis Support",
      text: "Writing a Ph.D. thesis can be intimidating. Our team guides you through research, writing, editing, and formatting...",
      color: "bg-blue-400",
      side: "right",
    },
  ];


  return (
    <section className="overflow-hidden pt-20 pb-12 lg:pt-[120px] lg:pb-[90px] bg-black dark:bg-dark">
      <div className="container mx-auto">
        <motion.div
          className="flex flex-wrap items-center justify-between -mx-4"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Images */}
          <div className="w-full px-4 lg:w-6/12">
            <div className="flex items-center -mx-3 sm:-mx-4">
              <div className="w-full px-3 sm:px-4 xl:w-1/2 space-y-6">
                <motion.div variants={slideLeft} className="py-3 sm:py-4">
                  <img
                    src="/image1.jpg"
                    alt="Our team at work"
                    className="w-full rounded-2xl shadow-lg"
                  />
                </motion.div>
                <motion.div variants={slideLeft} className="py-3 sm:py-4">
                  <img
                    src="/image2.jpg"
                    alt="Innovative technology"
                    className="w-full rounded-2xl shadow-lg"
                  />
                </motion.div>
              </div>

              <div className="w-full px-3 sm:px-4 xl:w-1/2">
                <motion.div variants={slideRight} className="relative z-10 my-4">
                  <img
                    src="/image3.jpg"
                    alt="Client engagement"
                    className="w-full rounded-2xl shadow-lg"
                  />
                  <span className="absolute -right-7 -bottom-7 z-[-1]">
                    <svg
                      width={134}
                      height={106}
                      viewBox="0 0 134 106"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {/* SVG circles here */}
                    </svg>
                  </span>
                </motion.div>
              </div>
            </div>
          </div>

          {/* Text Section with Boxes */}
          <div className="w-full px-4 lg:w-1/2 xl:w-5/12">
            <div className="mt-10 lg:mt-0 space-y-6">
              {/* Heading Box */}
              <div className="bg-white rounded-2xl p-6 shadow-xl border-l-4 border-orange-600">
                <span className="text-4xl md:text-5xl font-bold text-orange-700">
                  Why Choose Mindspark Revolutions
                </span>
              </div>

              {/* Subheading Box */}
              <div className="bg-white rounded-2xl p-6 shadow-xl border-l-4 border-orange-600">
                <h2 className="text-3xl font-bold text-orange-700 py-2">
                  Innovation. Expertise. Results.
                </h2>
                <p className="mt-4 text-lg text-orange-700">
                  At Mindspark Revolutions, we combine creativity with cutting-edge technology to deliver solutions that drive real impact. Our dedicated team partners with you to bring ideas to life with precision, innovation, and excellence.
                </p>
              </div>

              {/* List Box */}
              <div className="bg-white rounded-2xl p-6 shadow-xl border-l-4 border-orange-600">
                <ul className="space-y-4">
                  {[
                    "Creative & Innovative Solutions",
                    "Customer-Centric Approach",
                    "Commitment to Quality & Excellence",
                  ].map((item, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <svg
                        className="w-6 h-6 text-orange-700"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-lg text-orange-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="relative w-full max-w-6xl mx-auto py-10">
        {/* Vertical line */}
        <div className="absolute left-1/2 transform -translate-x-1/2 w-1 bg-blue-800 h-full"></div>

        {data.map((item, index) => (
          <div key={index} className="relative flex w-full my-8">
            {item.side === "left" ? (
              <>
                <div className="w-1/2 pr-8 text-right">
                  <div className={`inline-block text-left p-6 rounded-lg ${item.color} text-white`}>
                    <h3 className="font-bold text-lg mb-2">{item.title}</h3>
                    <p className="text-sm">{item.text}</p>
                  </div>
                </div>
                <div className="w-1/2"></div>
              </>
            ) : (
              <>
                <div className="w-1/2"></div>
                <div className="w-1/2 pl-8 text-left">
                  <div className={`inline-block text-left p-6 rounded-lg ${item.color} text-white`}>
                    <h3 className="font-bold text-lg mb-2">{item.title}</h3>
                    <p className="text-sm">{item.text}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
